import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Impersonation = ApplicationRecord.extend({
  attrs: {
    access_token: attr({ type: String }),
    customer_id: attr({ type: String }),
  },
  static: {
    endpoint: '/impersonations',
    jsonapiType: 'authentication-impersonations',
  },
});

export default Impersonation;
